module.exports = __webpack_public_path__ + "img/ruby.75a7deda.svg";